import React from 'react';
import { EntityForm } from '../../../widgets/Forms';
import ViewUtils from '../../../ViewUtils';
import OnlineAssessorDocuments from "./OnlineAssessorDocuments";
import OnlineAssessorDocumentDialog from "./OnlineAssessorDocumentDialog";
import { SelectItem } from '../../../widgets/SelectItem';



const utils = new ViewUtils();
export const OnlineAssessorDocumentsForm = React.forwardRef((props, ref) => {
    const [documentsDialogOpen, setdocumentsDialogOpen] = React.useState(false);
    const [assessorFileName, setAssessorFileName] = React.useState('');
    const [DocURL, setDocURL] = React.useState(null);
    const [showAssessorDocDialog, setShowAssessorDocDialog] = React.useState(false);
    const [showTable, setshowTable] = React.useState(true);
    
    const setDialogOpen = () => {
        setdocumentsDialogOpen(true);
    };

    //allows you to download a document you've just uploaded by clicking on the cell
    const handleCellSelect = (rowid, headCell) => {
        let url = "api/sims/OnlineAssessorRegistration/getDocument?documentID=" + rowid;
        utils.invokeUrlExternal(url, (response) => {
            var blob = new Blob([base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();

        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );
    };

    //converts the base64 document to allow for download
    const base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    const postUploadHandler = (save, cancel) => {
        //Successful upload
        if (save === true) {
            setshowTable(false);
            setdocumentsDialogOpen(false);
            setshowTable(true);
        }
        //Close dialog
        else if (cancel === true) {
            setdocumentsDialogOpen(false);
        }
        //Error on upload
        else {
            setdocumentsDialogOpen(false);
        }
        props.verifyDocumentCompletion();
    };
    

    return (
        <EntityForm ref={ref} viewId="assessor" values={props.data} dataURL='api/sims/OnlineAssessorRegistration/getfind'
            entityLookupController={props.entityLookupController} org="saseta" IsExternal={props.IsExternal}
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="AssessorForm">
                    <table cellPadding="2" width="80%">
                        <tbody>
                            <tr>
                                <td>
                                    <SelectItem
                                        dataUrl="api/sims/OnlineAssessorRegistration/GetLookupList?listId=OnlineRegistrationDocumentType"
                                        id="DocumentTypeID"
                                        label="Document Type"
                                        className="{classes.select} w-100"
                                        allowEmptyValue={true}
                                        checkRefreshToken={!props.IsExternal}
                                        form={form}
                                        InputProps={{
                                            readOnly: props.disableFields
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br></br>
                    <table cellPadding="2" width="80%">
                        <tbody>
                            <tr>
                                <td >
                                <div>
                                    <OnlineAssessorDocumentDialog
                                        open={documentsDialogOpen}
                                        closeHandler={(save, cancel) => postUploadHandler(save, cancel)}
                                        postUrl="api/sims/OnlineAssessorRegistration/AddOnlineAssessorDocument"
                                        EntityID={props.tempKey}
                                        checkRefreshToken={!props.IsExternal}
                                        buttonLabel={"Upload Document"}
                                        DocumentType={form.values["DocumentTypeID"]}
                                        fileName={assessorFileName}
                                        _setFilename={(name) => { setAssessorFileName(name) }}
                                    />
                                    </div>
                                </td>
                                <br></br>
                                <br></br>
                            </tr>
                        </tbody>
                    </table>
                    <p></p>
                    {showTable == true && (
                        <OnlineAssessorDocuments handleCell={(rowid, headCell) => handleCellSelect(rowid, headCell)} checkRefreshToken={!props.IsExternal}
                            documentsDataUrl="api/sims/OnlineAssessorRegistration/GetOnlineAssessorDocuments" moduleName="UG" selection={props.tempKey} />

                    )}
                </form>
            }
        </EntityForm>
    );
})

